import { 
    Accordion, 
    AccordionSummary, 
    AccordionDetails, 
    TextField, 
    Button, 
    Typography,
    Box,
    CircularProgress,
    Grid
  } from "@mui/material";
  import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
  import LocalShippingIcon from "@mui/icons-material/LocalShipping";
  import { OrderItem } from "../types/types";
  
  export const FulfillmentAccordion = ({
    orderItems,
    selectedItems,
    trackingNumber,
    carrier,
    notes,
    isSubmitting,
    onQuantityChange,
    onTrackingChange,
    onCarrierChange,
    onNotesChange,
    onSubmit
  }: {
    orderItems: OrderItem[],
    selectedItems: { [key: string]: number },
    trackingNumber: string,
    carrier: string,
    notes: string,
    isSubmitting: boolean,
    onQuantityChange: (productId: number, variantId: number | null, quantity: number) => void,
    onTrackingChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    onCarrierChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    onNotesChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    onSubmit: () => void
  }) => (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">Create Fulfillment</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {orderItems.length > 0 ? (
          <Box mt={2}>
            <Typography variant="subtitle1" gutterBottom>
              Items to Ship (Remaining Quantities):
            </Typography>
            {orderItems.map((item) => {
              const key = `${item.product_id}-${item.variant_id || 'null'}`;
              return (
                <Box key={key} display="flex" alignItems="center" gap={2} mb={3}>
                  <Typography variant="body2" flexGrow={1}>
                    {item.product_name}
                    {item.variant_name && ` (${item.variant_name})`} - 
                    Remaining: {item.remaining_quantity}
                  </Typography>
                  <TextField
                    type="number"
                    size="small"
                    value={selectedItems[key] || 0}
                    onChange={(e) => 
                      onQuantityChange(
                        item.product_id, 
                        item.variant_id || null, 
                        parseInt(e.target.value) || 0
                      )
                    }
                    inputProps={{ 
                      min: 0, 
                      max: item.remaining_quantity 
                    }}
                    sx={{ width: 100 }}
                  />
                </Box>
              );
            })}
          </Box>
        ) : (
          <Typography>No items available for fulfillment</Typography>
        )}
  
        <Grid container spacing={2} mt={2}>
          <Grid  size={{xs: 12, sm : 6}}>
            <TextField
              label="Tracking Number *"
              fullWidth
              value={trackingNumber}
              onChange={onTrackingChange}
            />
          </Grid>
          <Grid  size={{xs: 12, sm : 6}}>
            <TextField
              label="Carrier"
              fullWidth
              value={carrier}
              onChange={onCarrierChange}
            />
          </Grid>
          <Grid  size={{xs: 12}}>
            <TextField
              label="Notes (optional)"
              fullWidth
              multiline
              minRows={2}
              value={notes}
              onChange={onNotesChange}
            />
          </Grid>
        </Grid>
  
        <Box mt={3}>
          <Button
            variant="contained"
            color="primary"
            onClick={onSubmit}
            startIcon={<LocalShippingIcon />}
            disabled={isSubmitting || !trackingNumber}
          >
            {isSubmitting ? <CircularProgress size={24} /> : "Create Shipment"}
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );